import { render, staticRenderFns } from "./uploadPicture.vue?vue&type=template&id=b99aaf58&scoped=true&"
import script from "./uploadPicture.vue?vue&type=script&lang=js&"
export * from "./uploadPicture.vue?vue&type=script&lang=js&"
import style0 from "./uploadPicture.vue?vue&type=style&index=0&id=b99aaf58&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b99aaf58",
  null
  
)

export default component.exports